import React from "react";
import { Link } from "react-router-dom";   // ✅ Added
import "./Footer.css";
import logo from "../assets/a2z2.jpg";
import footerLogoMobile from "../assets/footer-logo.webp";

import {
  FaInstagram,
  FaWhatsapp
} from "react-icons/fa6";

import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";

function Footer() {
  const phoneNumber = "9440668806";
  const message = encodeURIComponent(
    "Hi! I'm interested in blinds. Please share options and pricing."
  );

  const whatsappLink = `https://wa.me/91${phoneNumber}?text=${message}`;
  const instagramLink = "https://www.instagram.com/atoz_blinds/";

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-left">
          <div className="footer-brand">
            <div className="logo-box">
              <img
                src={logo}
                alt="A to Z Blinds Logo"
                className="footer-logo footer-logo--desktop"
              />
              <img
                src={footerLogoMobile}
                alt="Footer Logo"
                className="footer-logo footer-logo--mobile"
              />
            </div>

            <p className="by-text">by Sri Latha Enterprises</p>
          </div>

          <h2 className="footer-heading">Complete Window Blind Solutions</h2>

          <p className="description">
            Providing premium window blinds <br />
            for homes, offices, and commercial <br />
            spaces for over 35 years.
          </p>

          {/* SOCIAL ICONS */}
          <div className="social-icons">
            <a
              href={instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              title="Open Instagram"
            >
              <FaInstagram />
            </a>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              title="Chat on WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>

        </div>

        {/* CENTER */}
        <div className="footer-center">
          <h2 className="footer-title">Our Blinds</h2>
          <ul>
            <li>Roller Blinds</li>
            <li>Custom Blinds</li>
            <li>Zebra Blinds</li>
            <li>Vertical Blinds</li>
            <li>Venetian Blinds</li>
            <li>Wooden Blinds</li>
            <li>PVC Exterior Blinds</li>
            <li>Bamboo Blinds</li>
            <li>Motorised Roller Blinds</li>
            <li>Industrial Blinds</li>
          </ul>
        </div>

        {/* RIGHT */}
        <div className="footer-right">
          <h2 className="footer-title">Quick Links</h2>

          <ul className="quick-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/about">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>

          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Hyderabad, Telangana
            </p>
            <p>
              <FaPhoneAlt /> +91 9440668806
            </p>
            <p>
              <FaEnvelope /> info@atozblinds.in
            </p>
            <p>
              <FaClock /> Mon – Sat | 9:00 AM – 7:00 PM
            </p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2026 A to Z Blinds. All Rights Reserved.
        <span className="footer-powered">
          {" "}
          Powered by{" "}
          <a
            href="https://vrnd.tech"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-powered__link"
          >
            VRND Business Solutions
          </a>
        </span>
      </div>
    </footer>
  );
}

export default Footer;